import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiService } from 'src/app/service/api.service';

@Component({
  selector: 'app-ai-chat',
  templateUrl: './ai-chat.component.html',
  styleUrls: ['./ai-chat.component.css']
})
export class AiChatComponent implements OnInit {

  isOpen = false;
  showAiChat = false;
  // chatbotUrl = 'https://ai.fujishka.com/?url=fujishkacloud.in&branch_id=13&user_id=3&company_code=FJK';
  chatbotUrl = 'https://ai.fujishka.com/?' + localStorage.getItem('ai_params');

  safeChatbotUrl: any;
  isLoaded = false;
  isIframeLoading = false;

  constructor(private sanitizer: DomSanitizer,private apiService: ApiService) {}

  ngOnInit() {
    this.sanitizeUrl();
    if(localStorage.getItem('ai_params')){
      console.log('ai_params');
      console.log(localStorage.getItem('ai_params'));
      this.showAiChat = true;
    }
  }

  sanitizeUrl() {
    this.safeChatbotUrl = (this.chatbotUrl) ? this.sanitizer.bypassSecurityTrustResourceUrl(this.chatbotUrl) : null;
  }

  toggleChat() {
    this.isOpen = !this.isOpen;

    if (this.isOpen && !this.isLoaded) {
      this.isLoaded = true;
      this.isIframeLoading = true;
    }
  }

  closeChat() {
    this.isOpen = false;
  }

  onIframeLoad() {
    this.isIframeLoading = false;
  }
}